import React, { memo, useEffect, useRef } from "react";
import Lottie, { LottieRefCurrentProps } from "lottie-react";
import invoiceAnimation from "ui/theme/animations/invoice.json";
import Logo from "ui/modules/public/components/Logo/Logo";

const ForgotPasswordIntro: React.FC = () => {
  const lottieRef = useRef<LottieRefCurrentProps>(null);

  useEffect(() => {
    if (lottieRef.current) {
      lottieRef.current.setSpeed(0.5);
    }
  }, []);

  return (
    <div className="hidden lg:flex w-1/2 bg-blue-700 h-screen flex-col relative">
      <Logo variant="light" animated className="absolute top-8 left-8" />

      <div className="flex flex-col items-center justify-center flex-1">
        <Lottie
          lottieRef={lottieRef}
          animationData={invoiceAnimation}
          autoplay={true}
          loop={true}
          className="w-[400px] h-auto"
        />
        <div className="text-center max-w-md mt-4">
          <h1 className="text-4xl leading-[46px] font-bold mb-3 text-white">
            Dobro došli u Orytron
          </h1>
          <p className="text-lg opacity-80 text-blue-50">
            Upravljajte svojom flotom vozila brzo i jednostavno
          </p>
        </div>
      </div>
    </div>
  );
};

export default memo(ForgotPasswordIntro);
